// ローディング判定
jQuery(window).on("load", function() {
  jQuery(function() {
    let swipeOption = {
      loop: true,
      slidesPerView: 1,
      pagination: {
        el: ".swiper-pagination", //ページネーションの要素
        type: "bullets", //ページネーションの種類
        clickable: true //クリックに反応させる
      },
      navigation: {
        nextEl: ".swiper-button-next", // 「次へ」ボタン要素のクラス
        prevEl: ".swiper-button-prev" // 「前へ」ボタン要素のクラス
      }
    };
    new Swiper(".swiper", swipeOption);
  });
});
